import { render, staticRenderFns } from "./Village.vue?vue&type=template&id=ae4ef31a&scoped=true"
import script from "./Village.vue?vue&type=script&lang=js"
export * from "./Village.vue?vue&type=script&lang=js"
import style0 from "./Village.vue?vue&type=style&index=0&id=ae4ef31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4ef31a",
  null
  
)

export default component.exports